import { Book } from "@app/types";
import BookItem from "../book-item";

interface BookGridProps {
  books: Book[];
}

function BookGrid({ books }: BookGridProps) {
  return (
    <div className="flex overflow-x-auto scroll-smooth gap-8">
      {books.map((book) => (
        <BookItem key={book.id} book={book} />
      ))}
    </div>
  );
}

export default BookGrid;
